import React from 'react'
import { useLocation } from 'react-router-dom'

const SidebarFooter = ({isConnected}) => {
  const location=useLocation()
  const currentPath=location.pathname
  return (
    <>
     <div className="sidebar-footer">
          <div className="system-status">
            <span
              className={`status-dot ${isConnected ? "ok" : "error"}`}
            ></span>
            <span>
          {isConnected
          ? `Connected - ${
              currentPath === "/test-env"
                ? "Pallasai_Test"
                : currentPath === "/dev-env"
                ? "HCS-DEV"
                : currentPath === "/san-env"
                ? "SAN"
                : currentPath === "/san-prod-env"
                ? "SAN-PROD"
                : currentPath === "/cobl-env"
                ? "Cobl"
                : currentPath === "/demo-env"
                ? "Demo"
                :currentPath === "/hcinternal-env"
                ? "hcinternal"
                : "---"
            }`
          : "Disconnected"}
          </span>

          </div>
        </div>
    </>
  )
}

export default SidebarFooter